export default __webpack_public_path__ + "static/media/tinyImg4.5ea1f749.png";